module.exports = __webpack_public_path__ + "static/media/big_phone.dca44b3a.png";